
$(document).ready(function () {
  function toggleMenu() {
    const menuMobile = $('#menu-mobile');
    const menuButtonShow = $('#menu-button-show');
    const menuButtonHide = $('#menu-button-hide');


    menuButtonShow.on('click', function (e) {
      e.preventDefault();
      menuMobile.addClass('menu-open');
    });

    // Zamknięcie menu
    menuButtonHide.on('click', function (e) {
      e.preventDefault();
      menuMobile.removeClass('menu-open');
    });

  }


  function handleScroll() {
    $(window).on('scroll', function () {
      const header = $('.header');
      const headerPost = $('#header');

      if ($(this).scrollTop() > 50) {
        header.addClass('scrolled');
        headerPost.addClass('scrolled');
      } else {
        header.removeClass('scrolled');
        headerPost.removeClass('scrolled');
      }
    });
  }

  toggleMenu();
  handleScroll();
});

document.addEventListener('DOMContentLoaded', function () {
  var formContainer = document.querySelector('.form');
  if (formContainer) {
    var formSubject = formContainer.getAttribute('data-form-subject');
    var input = formContainer.querySelector('input[name="form_subject_field"]');
    if (input) {
      input.value = formSubject;
    } else {

      var hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'form_subject_field';
      hiddenInput.value = formSubject;
      var formElement = formContainer.querySelector('form');
      if (formElement) {
        formElement.appendChild(hiddenInput);
      }
    }
  }
});


// WEBPACK FOOTER //
// ./scripts/main.js